import React from 'react'
import styled from 'styled-components'
import Card from './Card'
import { InnerLayout } from './Layout'
// import card from '../../Assets/img/creditcard.png';
import check from '../../Assets/img/check.svg';
import checkDisabled from '../../Assets/img/check-disabled.svg';
import DetailCard from './DetailCard';
import { Container } from "react-bootstrap";
import Particle from "../Particle";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";



const PricingCard1 = () => {

   const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/courses"); // This will navigate to the "/another-page" route
  };

    
    return (
        <Container >
       <ParticleWrapper>
                <Particle />
            </ParticleWrapper>
      <PaymentStyled id='pricing'>
         <InnerLayout>
            <div data-aos='fade-down-right'>
               <h3 className="small-heading">
                  Web-App Development Training
               </h3>
               <p className="c-para">Building Ethical, User-Centered Digital Solutions </p>
             
               <p>The Web/App Development Training at Choicest Fruit® is designed to empower young people 
                ages 14–24 to become not just coders, but creative problem-solvers and ethical innovators. 
                Participants learn to assess their community’s tech needs and collaborate on building 
                functional, user-centered websites and apps that are both effective and responsible.

                 Whether in-person, virtual, or hybrid, this training is accessible to all—no prior coding 
                 experience required.</p>
             
                </div>
                <Button onClick={handleClick}>View Trainings</Button>
            <div className='card-con'>
               <Card
                  account={'What Makes This Training Unique'}                 
                  text={'Our approach goes beyond the code. Learners explore:'}
                  button={'Register Here'}
                  // card={card}
                  link="https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform" 
                //   active={active}
              
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Ethical Frameworks in Design – ensuring technology is inclusive, accessible, and free from harmful biases. '}
                  text2={'Human-Centered Development – identifying user needs, including users in the design process, and making informed design decisions before writing a single line of code.'}
                  text3={'Creativity with Purpose – using design and usability principles to balance functionality with meaningful impact in communities.'}
                  text4={'Real-World Applications – collaborating on projects that benefit local organizations and causes, building a portfolio of work that makes a difference.'}
                  text5={'Collaboration & Communication – working in teams, developing both leadership and technical skills.'}
                  text6={' Skills & Tools – mastering industry-standard technologies and tools used by professional developers.'}
                
               />

               <Card
                  account={'Payment'}
                  amount={'$350'}
                  text={'A seamless and user-friendly payment integration.'}
                      button={'Pay Here'}
                      link="https://checkout.square.site/merchant/MLAY6G9T625V1/checkout/DTWEX7RYEEGCS5AFJTESDYMD" 
                  // card={card}                
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Training Length: 2 months.'}
                  text2={'Experience: No programming experience needed.'}
                  text3={'Certification: Certificate awarded upon completion.'}
                  text4={'Training Setting: In-Person|Remote|Hybrid.'}
                  text5={'Software Requirements: No paid software required.'}
                  text6={'Training Requirements: Access to internet.'}
                //   text7={'Exchange 24 currencies'}
                //   text8={'Multi-user access'}
                 />

           </div>
         </InnerLayout>
            </PaymentStyled>
            <Container>
                <DetailCard/>
                </Container>
            </Container>
      
   )
}


const ParticleWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;  // Place it behind all other content
`;

const PaymentStyled = styled.section`
 .card-con {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2rem; /* Reduce the gap between the cards */
    padding-top: 4rem; /* Reduce top padding */
    
    /* Optional: Use max-width to control the card's maximum size */
    max-width: 1200px;
    margin: 0 auto;
        
    @media screen and (max-width: 689px) {
      grid-template-columns: 1fr; /* Stack cards on mobile */
    }
  }

  p {
    text-align: center;
  }
`



export default PricingCard1
